import React from 'react';
import backgroundImage from './../../assets/images/2.jpg';
import styles from './Section1.module.css';

const Section1: React.FC = () => (
  <section id="section1" className={styles.section} style={{ backgroundImage: `url(${backgroundImage})` }}>
    <div className={styles.content}>
      <p className={styles.eyebrow}>За нас</p>
      <h2>Партньор, на когото можете да разчитате.</h2>
      <p className={styles.intro}>ГеоСвят МАП ЕООД обединява екип от млади инженери с над 10 години опит в проектирането и изпълнението на инвестиционни проекти.</p>
      <p>Работим с професионална техника от последно поколение и специализиран софтуер, за да превърнем сложните задачи в точни и ясни решения.</p>
      <div className={styles.specialties}>
        <span>Геодезическо заснемане</span><span>Кадастрални услуги</span><span>Трасиране</span>
      </div>
      <p className={styles.note}>Вписани сме в Регистъра на правоспособните лица към Агенцията по геодезия, картография и кадастър на Република България.</p>
    </div>
  </section>
);
export default Section1;
